<template>
  <default-view>

    <span slot="header">Search</span>

    <template slot="toolbar-items"></template>

    <template slot="content" id="search-view">

      <!--      <v-container>-->
      <!--        <v-row>-->
      <!--          <v-col cols="12">-->
      <!--            <v-text-field label="Condition" v-model="search_text"/>-->
      <!--          </v-col>-->
      <!--        </v-row>-->
      <!--        <v-row>-->
      <!--          <v-col>-->
      <!--            иконка-->
      <!--            <v-icon>account</v-icon>-->
      <!--          </v-col>-->
      <!--        </v-row>-->
      <!--      </v-container>-->

      <v-layout row>
        <v-flex xl8 lg8 md8 sm12 xs12 style="background-color: #AAFFAA">
          <v-text-field outlined dense hide-details
                        label="Field 1"
          ></v-text-field>
        </v-flex>
        <v-flex xl4 lg4 md4 sm12 xs12 style="background-color: #42b983">
          <v-text-field outlined dense hide-details
                        label="Field 2"
          ></v-text-field>
        </v-flex>
      </v-layout>

      <div style="background-color: #fcedd9;">
        <v-container
          v-for="align in alignments"
          :key="align"
          class="grey lighten-5 mb-6"
        >
          <v-row
            :align="align"
            no-gutters
            style="height: 150px;"
          >
            <v-col
              v-for="n in 3"
              :key="n"
            >
              <v-card
                class="pa-2"
                outlined
                tile
              >
                One of three columns
              </v-card>
            </v-col>
          </v-row>
        </v-container>

        <v-container class="grey lighten-5">
          <v-row
            no-gutters
            style="height: 150px;"
          >
            <v-col
              v-for="align in alignments"
              :key="align"
              :align-self="align"
            >
              <v-card
                class="pa-2"
                outlined
                tile
              >
                One of three columns
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </div>

    </template>

  </default-view>


</template>

<script>
	import DefaultView from "./app/DefaultView"

	export default {
		name: "SearchView",

		components: {DefaultView},

		data: function () {
			return {
				search_text: '',
				alignments: [
					'start',
					'center',
					'end',
				],

			}
		},
	}

</script>

<style scoped>

</style>